'use client'

import { RadioSingleSelect } from '@components/primitives/HtmlForm/RadioSingleSelect.client'
import { Text } from '@components/primitives/Text'
import { faMars } from '@fortawesome/pro-solid-svg-icons/faMars'
import { faVenus } from '@fortawesome/pro-solid-svg-icons/faVenus'
import { faVenusMars } from '@fortawesome/pro-solid-svg-icons/faVenusMars'
import { debounceTrackQuestionModified } from './trackQuestionModified'
import type { DemographicsCollectElementProps } from './types'

const debouncedEventTracking = debounceTrackQuestionModified('genderIdentities')

export default function CollectGenderIdentities({
  formRef,
  patientProfileData: { genderIdentities },
  questionConfig,
}: DemographicsCollectElementProps) {
  const handleInputChange = (newInputValue: string | string[]) => {
    const submittedValue = Array.isArray(newInputValue)
      ? newInputValue
      : [newInputValue]

    debouncedEventTracking(submittedValue)
  }

  return (
    <div className='flex w-full flex-col gap-2'>
      <Text
        className='text-neutral900'
        element={'p'}
        styleName='h3'
        value='Which gender expression do you identify with?'
      />
      <Text
        className='text-neutral900'
        element={'p'}
        styleName='p-small'
        value='Why we ask: medical research has historically struggled with diversity. Help us change that!'
      />
      <div className='grid grid-cols-1 gap-2 md:grid-cols-3'>
        <RadioSingleSelect
          autoSubmitFormOnChoice
          defaultValue={genderIdentities?.[0]}
          formRef={formRef}
          name={questionConfig.id}
          onChange={handleInputChange}
          options={[
            { icon: faVenus, label: 'Woman', value: 'Female' },
            { icon: faMars, label: 'Man', value: 'Male' },
            { icon: faVenusMars, label: 'Other', value: 'Other' },
          ]}
          required={!questionConfig.skippable}
        />
      </div>
    </div>
  )
}
